import { createElement, HTMLAttributes } from "react";
import { withStyledMarkdown } from "../../theme/with-styled-markdown";

interface IOwnProps<T> extends HTMLAttributes<T> {
    content: string;
    tag?: string;
}

function RawHTML<T>({ content, tag = "div", ...props }: IOwnProps<T>) {
    return createElement(tag, {
        dangerouslySetInnerHTML: {
            __html: content,
        },
        ...props,
    });
}

export default withStyledMarkdown(RawHTML);
